import Keycloak from 'keycloak-js';

// Load configuration from environment variables
const realmUrl = (import.meta.env.VITE_KEYCLOAK_REALM_URL || 'http://localhost:8080/realms/master').replace(/\/+$/, '');
const [url, realm] = realmUrl.split('/realms/');

const keycloakConfig = {
  url,
  realm,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'token-server-ui',
};

// Create Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

// Keycloak initialization options
export const keycloakInitOptions = {
  onLoad: 'login-required' as const,
  checkLoginIframe: false,
  pkceMethod: 'S256' as const,
};

export default keycloak;
